export const sanitize = (input) => {
  const doc = new DOMParser().parseFromString(input, 'text/html')
  for (const elm of doc.querySelectorAll('*')) {
    for (const attrib of elm.attributes) {
      if (attrib.name.startsWith('on')) {
        elm.removeAttribute(attrib.name)
      }
    }
  }
  return doc.body.innerHTML
}

export const toggleHtmlScrollable = (scrollable: boolean) => {
  if (typeof window == 'undefined') return

  if (!scrollable) {
    const scrollTop = window.document.documentElement.scrollTop
    window.document.body.style.maxHeight = '0px'

    if (scrollTop !== 0) {
      /*
        Modal was auto-scrolling to the top when opened a second time due to unintended scroll reset. 
        This fix preserves the scroll position when reopening the modal.
      */
      window.document.body.scrollTop = scrollTop
    }
  } else {
    const scrollTop = window.document.body.scrollTop
    window.document.body.style.maxHeight = 'revert'
    window.document.documentElement.scrollTop = scrollTop
  }
}

export const detectHtmlTag = (input: string, tagName: string, attributes: string[] = []) => {
  const tag = tagName.toLowerCase()

  const attrPattern = attributes
    .map((attr) => {
      const [key, value] = attr.split('=')
      // const realKey = key === 'className' ? 'class' : key
      const val = value.replace(/['"]/g, '')
      return `${key}\\s*=\\s*['"]${val}['"]`
    })
    .join('\\s+')

  const pattern = attrPattern ? new RegExp(`<${tag}\\s+${attrPattern}[^>]*>`, 'i') : new RegExp(`<${tag}[^>]*>`, 'i')

  // console.log(detectHtmlTag(html, "a")); // true
  // console.log(detectHtmlTag(html, "a", ["className='hehe'"])); // true
  // console.log(detectHtmlTag(html, "a", ["className='hehe'", "href='/klelvin'"])); // true
  // console.log(detectHtmlTag(html, "a", ["className='nope'"])); // false

  return pattern.test(input)
}
